import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'
import axios from 'axios/index'
import { APIURL, IMAGE_FULL_URL, IMAGE_NOPHOTO_URL, IMAGE_THUMB_URL, PAGE10 } from '../../../config/config'
import pdfMake from 'pdfmake/build/pdfmake'
import * as moment from 'moment'
import CarClaimItemDetail from "../CarClaimItemDetail";

class CarClaimList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      lists: [],
      modalCloseClaim: false,
      carClaim: {},
      page: 1,
      car_claim_count: 0,
      carBase64Img: ''
    }
    this.printClaim = this.printClaim.bind(this)
    this.loadCarImageBase64 = this.loadCarImageBase64.bind(this)
    this.makeCarImgBase64 = this.makeCarImgBase64.bind(this)
    this.onClaimPrint = this.onClaimPrint.bind(this)

  }

  componentDidMount () {
    // this.loadData()
    this.loadCarClaimList(1)
    this.loadCarClaimCount()
  }


  onSearch() {
    let search_text = this.refs.input_search.value
    if(search_text===''){
      this.loadData()
      return;
    }

    axios.get(APIURL + '/car_claim/search/'+search_text.trim())
      .then(res => {
        this.setState({lists: res.data})
      }).catch(error => {
      this.setState({lists: []})
    })

  }

  onRefresh(){
    this.refs.input_search.value = ''
    this.loadData()
  }

  loadData() {
    axios.get(APIURL + '/car_claim/list')
      .then(res => {
        this.setState({lists: res.data})
      }).catch(error => {
        this.setState({lists: []})
    })
  }

  loadCarClaimList(page) {

    if (typeof page === 'undefined') page = 1

    let uri = APIURL + '/car_claim/page/'+page

    axios.get(uri)
        .then(res => {
          this.setState({lists: res.data})
        }).catch(error => {
      this.setState({lists: []})
    })


  }

  loadCarClaimCount() {
    let uri = APIURL + '/car_claim/count/all'
    //car_sell_count
    axios.get(uri)
        .then(res => {
          this.setState({
            car_claim_count: res.data[0].car_claim_count
          });
        }).catch(error => {
      console.log(error)
    })
  }

  convertClaimStatusName(statusValue) {
    let statusList = [
      {status: 'start', name: 'ออกใบเคลม'},
      {status: 'process', name: 'กำลังดำเินการซ่อม'},
      {status: 'success', name: 'ซ่อมเสร็จรอลูกค้ามารับ'},
      {status: 'complete', name: 'ปิดเคลม'},
    ];
    let result = statusList.find(status => {
      return status.status === statusValue
    })
    return result.name;
  }

  convertImgToBase64URL(url, callback, outputFormat){
    let img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function(){
      let canvas = document.createElement('CANVAS'),
        ctx = canvas.getContext('2d'), dataURL;
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL(outputFormat);
      callback(dataURL);
      canvas = null;
    };
    img.src = url;
  }

   async onClaimPrint(carClaim) {
     let car_upload_id = carClaim.car_upload_id

     // console.log(carClaim)

     let image_url = ''
     if (carClaim.car_upload_filename !== null) {
       if (carClaim.car_upload_filename.includes('https')) {
         await this.makeCarImgBase64(car_upload_id);
         this.printClaim(carClaim, 'ใบเคลม/ช่าง')
       } else {
         image_url = IMAGE_FULL_URL + carClaim.car_upload_filename
         this.convertImgToBase64URL(image_url, (base64Img) => {
           this.setState({
             carBase64Img: base64Img
           }, () =>this.printClaim(carClaim, 'ใบเคลม/ช่าง') )
         })
       }
     } else {
       image_url = IMAGE_NOPHOTO_URL
       this.convertImgToBase64URL(image_url, (base64Img) => {
         this.setState({
           carBase64Img: base64Img
         }, () =>this.printClaim(carClaim, 'ใบเคลม/ช่าง') )
       })
     }



  }

  async makeCarImgBase64(car_upload_id) {
    try {
      await this.loadCarImageBase64(car_upload_id)
    } catch (e) {
      console.log(e)
    }
  }

  async loadCarImageBase64(car_upload_id) {
    let uri =  APIURL + '/car/image/' + car_upload_id;
    await axios.get(uri)
      .then(res => {
        let body = res.data.body
        this.setState({ carBase64Img: body })
      }).catch(error => {
        console.log('error:', error)
      })
  }

  printClaim(claimData, headerDocument) {
    // var car_claim_id = claimData.car_claim_id;

    let claim_date = moment(claimData.claim_date).locale('th').format('LL');
    let claim_name = moment(claimData.claim_name).locale('th').format('LL'); //claimData.claim_name;
    let claim_mobile = claimData.claim_mobile;
    let claim1_list1 = claimData.claim1_list1;
    let claim1_list2 = claimData.claim1_list2;
    // var claim2 = claimData.claim2;
    // var claim3 = claimData.claim3;
    // var car_name = carData.car_name;
    // var date_promise = carData.date_promise;
    let car_brand_name = claimData.car_brand_name
    let car_model_name = claimData.car_model_name
    let car_color_name = claimData.car_color_name
    let car_license_plate_new = claimData.car_license_plate_new
    // let car_upload_filename = ( typeof claimData.car_upload_filename === undefined ) ? 'noimage.png' : claimData.car_upload_filename
    // let car_url = IMAGE_THUMB_URL+car_upload_filename

    let  car_guaruntee_end_date = moment(claimData.car_sell_date).add(90, 'days').format('LL')
    // var  car_guaruntee_end_date = moment(car_guaruntee_add, "DD/MM/YYYY").locale('th').format('LL') // .format('LL')
    let base64Img = this.state.carBase64Img
    let gearbox_warranty = claimData.gearbox_warranty === null ? '': claimData.gearbox_warranty
    let gearbox_bank_name = claimData.gearbox_bank_name === null ? '': claimData.gearbox_bank_name
    let gearbox_warranty_expire = claimData.gearbox_warranty === 'รับประกันเครื่องเกียร์' ? moment(claimData.car_sell_date).add(1, 'years').locale('th').format('LL') : '-'

    let gearboxText = ''
    if (gearbox_warranty !== '') {
      if (claimData.gearbox_warranty === 'รับประกันเครื่องเกียร์') {
        gearboxText = 'ประกันเครื่องเกียร์: ' + gearbox_warranty + '  ธนาคารที่รับประกัน: ' + gearbox_bank_name + '   วันที่หมดประกัน: ' + gearbox_warranty_expire
      } else if (claimData.gearbox_warranty === 'ไม่รับประกันเครื่องเกียร์'){
        gearboxText = 'ประกันเครื่องเกียร์: ' + gearbox_warranty
      } else {
        gearboxText = 'ประกันเครื่องเกียร์: ไม่ระบุ'
      }
    } else {
      gearboxText = 'ประกันเครื่องเกียร์: ไม่ระบุ'
    }

    let gearbox = {
      columns: [
        {
          width: '100%',
          text: gearboxText ,
          style: 'textcenter'
        },
      ],
      columnGap: 20,
      lineHeight: 1.0,
      margin: [0, 0, 0, 0],
    }

    let gearboxCopy = {
      columns: [
        {
          width: '100%',
          text: gearboxText ,
          style: 'textcenter'
        },
      ],
      columnGap: 20,
      lineHeight: 1.0,
      margin: [0, 0, 0, 0],
    }

    // TODx: check load image from url
    // let image_url = ''
    // if (claimData.car_upload_filename !== null) {
    //   if (claimData.car_upload_filename.includes('https')) {
    //     image_url = claimData.car_upload_filename
    //   } else {
    //     image_url = IMAGE_FULL_URL + claimData.car_upload_filename
    //   }
    // } else {
    //   image_url = IMAGE_NOPHOTO_URL
    // }

    // this.convertImgToBase64URL(image_url, function(base64Img){

      let docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [ 56, 30, 56, 30 ], // margin: [left, top, right, bottom]
      content: [
        { text: headerDocument, style: 'bodyhead', lineHeight:1.2},
        {
          columns: [
            { width: '20%',
              text: '', style: 'bodycompany'
            },
            { width: '40%', style: 'bodycompany',
              text: '',
            },
            { width: '20%',
              text: '', style: 'bodycompany'
            },
            { width: '20%', style: 'body',
              text: 'Sale........................',
            },

          ],
          columnGap: 20,
          lineHeight:1
        },
        {
          columns: [
            {
              width: 140,
              image: base64Img
              //text: 'ภาพรถ'
            },
            { width: '80%',
              text: 'วันที่ออกใบงาน...'+ claim_date+ '  \nลูกค้ารับรถ...'+claim_name+'   \nเบอร์โทร...' + claim_mobile+'...\nหมดรับประกันรถวันที่: '+car_guaruntee_end_date,
              style: 'body'
            },
          ],
          columnGap: 20,
          lineHeight:1.2,
          margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
        },
        {
          columns: [
            { width: '100%',
              text: 'รถยี่ห้อ...'+ car_brand_name+'  รุ่น...'+car_model_name+ '   สี...'+ car_color_name +'  ทะเบียน...'+car_license_plate_new, style: 'textcenter'
            },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          margin: [ 0, 8, 0, 0 ],
        },
        gearbox,
        {
          columns: [
            { width: '100%', text: 'รายการ:', style: 'body' },
          ],
          columnGap: 20,
          margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
        },
        {
          columns: [
            { width: '50%', text: claim1_list1 , style: 'body'},
            { width: '50%', text: claim1_list2 , style: 'body'},
          ],
          columnGap: 20,
          margin: [ 8, 0, 0, 0 ], // margin: [left, top, right, bottom]
        },
        {
          columns: [
            {
              width: '100%',
              text: 'อนุมัติ....................................   ช่าง:ตรวจ....................................   Sale:ตรวจ....................................   ',
              style: 'textcenter'
            },
          ],
          columnGap: 20,
          lineHeight: 1.3,
          margin: [ 0, 14, 0, 20 ],
        },
        [
          { text: headerDocument, style: 'bodyhead', lineHeight:1.2},
          {
            columns: [
              { width: '20%',
                text: '', style: 'bodycompany'
              },
              { width: '40%', style: 'bodycompany',
                text: '',
              },
              { width: '20%',
                text: '', style: 'bodycompany'
              },
              { width: '20%', style: 'body',
                text: 'Sale........................',
              },
            ],
            columnGap: 20,
            lineHeight:1,
            margin: [ 0, 20, 0, 0 ],
          },
          {
            columns: [
              {
                width: 140,
                image: base64Img
                //text: 'ภาพรถ'
              },
              { width: '80%',
                text: 'วันที่ออกใบงาน...'+ claim_date+ '  \nลูกค้ารับรถ...'+claim_name+'   \nเบอร์โทร...' + claim_mobile+'...\nหมดรับประกันรถวันที่: '+car_guaruntee_end_date,
                style: 'body'
              },
            ],
            columnGap: 20,
            lineHeight:1.3,
            margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
          },
          {
            columns: [
              { width: '100%',
                text: 'รถยี่ห้อ...'+ car_brand_name+'  รุ่น...'+car_model_name+ '   สี...'+ car_color_name +'  ทะเบียน...'+car_license_plate_new, style: 'textcenter'
              },
            ],
            columnGap: 20,
            lineHeight: 1.3,
            margin: [ 0, 8, 0, 0 ],
          },
          gearboxCopy,
          {
            columns: [
              { width: '100%', text: 'รายการ:', style: 'body' },
            ],
            columnGap: 20,
            margin: [ 0, 8, 0, 0 ], // margin: [left, top, right, bottom]
          },
          {
            columns: [
              { width: '50%', text: claim1_list1 , style: 'body'},
              { width: '50%', text: claim1_list2 , style: 'body'},
            ],
            columnGap: 20,
            margin: [ 8, 0, 0, 0 ], // margin: [left, top, right, bottom]
          },
          {
            columns: [
              {
                width: '100%',
                text: 'อนุมัติ....................................   ช่าง:ตรวจ....................................   Sale:ตรวจ....................................   ',
                style: 'textcenter'
              },
            ],
            columnGap: 20,
            lineHeight: 1.3,
            margin: [ 0, 14, 0, 0 ],
          },

        ]

      ],
      styles: {
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        body: {
          fontSize: 16,
        },
        bodycompany: {
          fontSize: 16,
          bold: true,
        },
        textcenter: {
          fontSize: 16,
          alignment: 'center'
        },
      },
      defaultStyle: {
        font: 'THSarabunNew'
      }
    };
    //
      pdfMake.createPdf(docDefinition).open()
    // });
  }

  toggleCloseClaim() {
    this.setState({
      modalCloseClaim: !this.state.modalCloseClaim
    })
  }

  onCloseClaime(car_claim_id) {
    // alert('ปิดเคลม car_claim_id=' + car_claim_id);
    // this.toggleCloseClaim()
    axios.put(APIURL + '/car_claim/close/'+car_claim_id, {})
      .then((res) => {
        if (res.status === 200) {
          this.loadData()
          this.toggleCloseClaim()
        }

      }).catch((err) => {
      console.log(err)
    })
  }

  openModalCloseClaim(carClaim) {
    this.setState({
      carClaim: carClaim,
      modalCloseClaim: !this.state.modalCloseClaim
    })
  }

  redirectToClaimItems(carClaim) {
    let target = '/car-claim/items/?claim_id=' + carClaim.car_claim_id;
    // return <Redirect push to={target}/>
    this.props.history.push(target)
  }

  render() {

    let all_page = Math.ceil(this.state.car_claim_count/PAGE10);
    let page_array = Array.from(Array(all_page).keys());
    let tab_pages = page_array.map((page,index)=>{
      let page_tmp = page+1
      return (
          <li className="page-item" key={index}>
            <a className="page-link"
               href="no-script-url:0"
               onClick={()=>{   this.loadCarClaimList(page_tmp) }}>
              &nbsp;{page_tmp}&nbsp;
            </a>
          </li>
      )
    })

    var car_claim_count = this.state.car_claim_count
    var page = this.state.page
    var start_row = 0
    if(car_claim_count > 0  && page > 0){
      start_row = Number(page-1) * PAGE10
    }

    let tbodyList = this.state.lists.map((carClaim, index) => {

      // let car_upload_filename = ( typeof carClaim.car_upload_filename === undefined ) ? 'noimage.png' : carClaim.car_upload_filename

      let image_url = ''
      if (carClaim.car_upload_filename !== null) {
        if (carClaim.car_upload_filename.includes('https')) {
          image_url = carClaim.car_upload_filename
        } else {
          image_url = IMAGE_FULL_URL + carClaim.car_upload_filename
        }
      } else {
        image_url = IMAGE_NOPHOTO_URL
      }

      let order = 0
      if(this.state.is_search){
        order = index + 1
      }else{
        order = Number(car_claim_count-start_row)-index
      }

      let gearbox_warranty = carClaim.gearbox_warranty === null ? '': carClaim.gearbox_warranty
      let gearbox_bank_name = carClaim.gearbox_bank_name === null ? '': carClaim.gearbox_bank_name
      let gearbox_warranty_expire = carClaim.gearbox_warranty === 'รับประกันเครื่องเกียร์' ? moment(carClaim.car_sell_date).add(1, 'years').locale('th').format('LL') : '-'

      let gearboxText = ''
      if (gearbox_warranty !== '') {
        if (gearbox_warranty === 'รับประกันเครื่องเกียร์') {
          gearboxText = 'ประกันเครื่องเกียร์: ' + gearbox_warranty + <br/>+ 'ธนาคารที่รับประกัน: ' + gearbox_bank_name + <br/>+'วันที่หมดประกัน: ' + gearbox_warranty_expire
        } else if (carClaim.gearbox_warranty === 'ไม่รับประกันเครื่องเกียร์'){
          gearboxText = 'ประกันเครื่องเกียร์: ' + gearbox_warranty
        } else {
          gearboxText = 'ประกันเครื่องเกียร์: ไม่ระบุ'
        }
      } else {
        gearboxText = 'ประกันเครื่องเกียร์: ไม่ระบุ'
      }

      return (
        <tr key={index}>
          <td className="text-center" width="10%">
            {order}
            <br/>
            เลขใบเคลม# {carClaim.car_claim_id}
          </td>
          <td>
            วันที่ออกใบเคลม: {carClaim.claim_date} <br/>
            ลูกค้ารับรถ: {carClaim.claim_name} <br/>
            เบอร์โทร: {carClaim.claim_mobile} <br/>
            <img id={'img_'+carClaim.car_claim_id} src={image_url} className="img-cars" alt="car"/>
          </td>
          <td>
            ทะเบียน: {carClaim.car_license_plate_new} <br/>
            รถยี่ห้อ {carClaim.car_brand_name} รุ่น {carClaim.car_model_name} สี {carClaim.car_color_name} <br/>
            รายการ : <br/>
            {carClaim.claim1_list1} <br/>
            {carClaim.claim1_list2} <br/>

            <strong>
              หมายเหตุ:&nbsp;
              <span className="text-danger">
                  หมดรับประกันรถวันที่ { moment(carClaim.car_sell_date).add(90, 'days').format('LL')}
                 </span>
            </strong>

            <br/>
            <strong>
            {

              gearbox_warranty === 'รับประกันเครื่องเกียร์' ? <>

                <hr/>
                <span >การประกันเครื่องเกียร์: <span className="text-success">{gearbox_warranty}</span></span> <br/>
                <span>ธนาคารที่รับประกัน: {gearbox_bank_name}</span> <br/>
                <span>วันที่หมดประกัน: {gearbox_warranty_expire}</span> <br/>

                </> : gearboxText

            }
            </strong>

            {/*<div className={carClaim.claim2===''? 'hidden': ''}>
              <hr/>
              เคลมที่ 2 : <br/>
              {carClaim.claim2} <br/>
            </div>
            <div className={carClaim.claim3===''? 'hidden': ''}>
              <hr/>
              เคลมที่ 3 : <br/>
              {carClaim.claim3} <br/>
            </div>*/}
            <CarClaimItemDetail car_claim_id = {carClaim.car_claim_id} />
          </td>
          <td width="10%">
            {this.convertClaimStatusName(carClaim.status)}
          </td>
          <td className="align-top text-center"  width="15%" >
            <button type="button"
                    onClick={async () =>  {
                      await this.onClaimPrint(carClaim)
                      // this.printClaim(carClaim, 'ใบเคลม/ช่าง')
                    }}
                    className="btn btn-sm btn-primary"
                    style={styles.btnWidth}>
              <i className="icon-printer"></i> ใบเคลม
            </button>

            <button type="button"
                    onClick={() => {
                        this.openModalCloseClaim(carClaim);
                    }}
                    className="btn btn-sm btn-warning"
                    style={styles.btnWidth}>
              <i className="icon-disc"></i> ปิดเคลม
            </button>

            <button type="button"
                    onClick={() => {
                      this.redirectToClaimItems(carClaim)
                    }}
                    className="btn btn-sm btn-danger"
                    style={styles.btnWidth}>
              <i className="icon-list"></i> รายการซ่อม
            </button>

          </td>
        </tr>
      );
    });

    let tbodyEmpty = () => {
      return (
        <tr className="text-center">
          <td colSpan={5}><span className="text-danger">ไม่พบข้อมูล</span></td>
        </tr>
      )};

    return (
      <div className="card">
        <div className="card-block">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="card card-accent-primary">
                <div className="card-header">
                  <strong> ข้อมูลการเคลม/ส่งรถ </strong>

                  <input
                    onChange={this.onSearch.bind(this)}
                    ref="input_search"
                    style={styles.inputSearch}
                    className="form-control"
                    placeholder="ค้นหาตามชื่อรถ ทะเบียน"
                    type="text"
                  />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                  <button className="btn btn-primary"
                          style={styles.buttonHeight}
                          onClick={this.onRefresh.bind(this)}

                  >
                    <i className="icon-refresh"></i>
                  </button>
                </div>
                <div className="card-block">
                  <table className="table table-striped">
                    <thead>
                    <tr>
                      <th className="text-center">#</th>
                      <th className="text-center" width="20%">วันออกใบงาน</th>
                      <th>รายการ</th>
                      <th>สถานะ</th>
                      <th className="text-center">จัดการ</th>
                    </tr>
                    </thead>
                    <tbody>
                    {(tbodyList.length>0)? tbodyList: tbodyEmpty()}
                    </tbody>
                  </table>

                  <ul className= { this.state.is_search ? "hidden" : "pagination d-flex flex-wrap pagination-sm" }>
                    {tab_pages}
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modalCloseClaim} toggle={this.toggleCloseClaim.bind(this)}
               className={'modal-warning'}>
          <ModalHeader toggle={this.toggleCloseClaim.bind(this)}>คุณต้องการปิดเคลม</ModalHeader>
          <ModalBody>
            <h6>
              <strong> คุณต้องการปิดเคลมรถ ทะเบียน: {this.state.carClaim.car_license_plate_new} ใช่หรือไม่ ?? </strong> <br />
            <strong>
              รถยี่ห้อ {this.state.carClaim.car_brand_name} รุ่น {this.state.carClaim.car_model_name} สี {this.state.carClaim.car_color_name} <br/>
            </strong> </h6>
          </ModalBody>
          <ModalFooter>
            <Button color="warning"
                    onClick={this.onCloseClaime.bind(this, this.state.carClaim.car_claim_id)}>ตกลง</Button>{' '}
            <Button color="secondary" onClick={this.toggleCloseClaim.bind(this)}>ยกเลิก</Button>

          </ModalFooter>
        </Modal>

      </div>
    )
  }


}

const styles = {
  inputSearch: {
    marginLeft: 20,
    width: 300,
    display: 'inline'
  },
  buttonHeight: {
    height: 32,
    paddingTop:0,
    paddingBottom:0,
    display: 'inline',
    marginTop: '-0.35rem'
  },
  btnWidth: {
    width: 120,
    marginBottom: '0.35rem'
  },
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(CarClaimList)